import React from "react"
import Wrapper from "@components/Wrapper"
import styles from "./WeBelieve.module.scss"
import icon1 from "./Icon1.png"
import icon2 from "./Icon2.png"
import icon3 from "./Icon3.png"
import icon4 from "./Icon4.png"
import { OutboundLink } from "@assertiv/assertiv-gatsby-plugin-google-gtag"

const Card = props => {
  return (
    <div className={props.className}>
      <div className={styles.cardDiv}>
        <a target="_blank" href={props.href}>
          <img className="mb-5" src={props.imgSrc} alt={props.imgAlt}></img>
        </a>
      </div>
      {props.children}
    </div>
  )
}

const CardContent = props => {
  return (
    <div className="pb-10">
      <p className="proxima-nova--semi-bold fs-30pt mx-auto mb-2">
        <span className="d-inline-block">{props.line1}</span>{" "}
      </p>
      <span className={"fs-18pt " + styles.cardRegularText}>{props.line2}</span>
    </div>
  )
}

const WeBelieve = props => {
  return (
    <section className="container-fluid">
      <div className="row ml-0 mr-0 ">
        <Wrapper className={"w-100 text-center"} gap="outer">
          <div className="row bg-white justify-content-center pl-6 pr-6 pt-6">
            <div className="row">
              <div className="col-12 mt-10">
                <h3
                  className={
                    styles.title +
                    " proxima-nova--extra-bold text-secondary fs-30pt fs-lg-42pt"
                  }
                >
                  WHAT NEXT?
                </h3>
              </div>
            </div>
            <div className="row">
              <Card
                className={"col-12 col-lg-6 col-xl-6"}
                imgSrc={icon2}
                imgAlt="introduction"
                href="https://outlook.office365.com/owa/calendar/EngineID@engineid.com/bookings/"
              >
                <OutboundLink href="https://outlook.office365.com/owa/calendar/EngineID@engineid.com/bookings/" target="_blank">
                  <CardContent
                    line1="Schedule an Introduction with our Team"
                    line2="We can help identify the best approach to take in setting up Multi-Factor Authentication for your applications. Our team consists of consultants and developers who can provide expert guidance."
                  />
                </OutboundLink>
              </Card>
              
              <Card
                className={"col-12 col-lg-6 col-xl-6"}
                imgSrc={icon4}
                imgAlt="register"
                href="https://app.engineid.com/register"
              >
                <OutboundLink href="https://app.engineid.com/register" target="_blank">
                  <CardContent
                    line1="Try it for free"
                    line2="Register for a free organization and access our technical documentation to start building Multi-Factor Authentication into your application immediately."
                  />
                </OutboundLink>
              </Card>
            </div>
          </div>
        </Wrapper>
      </div>
    </section>
  )
}

export default WeBelieve
